import { render } from "./MultiSelectDropdown.vue?vue&type=template&id=227c36eb&scoped=true"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=js"

import "./MultiSelectDropdown.vue?vue&type=style&index=0&id=227c36eb&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227c36eb"]])

export default __exports__